import { Redirect, router } from 'expo-router'
import { withCardGate } from '@/src/experiences/card-accounts/withCardGate'
import { Loading } from '@/src/common/components/Loading'
import { useEvent } from 'tamagui'
import type { ComponentProps } from 'react'

export default withCardGate(function CardIndex({
  showCardManagement,
  applicationStatusInitialized,
}) {
  if (!applicationStatusInitialized) {
    return <Loading />
  }

  return (
    <Redirect
      href={
        showCardManagement ? '/main/(tabs)/card/card-management' : '/main/(tabs)/card/cardBenefits'
      }
    />
  )
})

type CardGateProvisions = ComponentProps<Parameters<typeof withCardGate>[0]>

export function useDismissToCardHome({
  showCardManagement,
  firstCardFetchFinished,
}: Pick<CardGateProvisions, 'showCardManagement' | 'firstCardFetchFinished'>) {
  return useEvent(() =>
    router.dismissTo(
      `/main/card${
        firstCardFetchFinished
          ? (`/${showCardManagement ? 'card-management' : 'cardBenefits'}` as const)
          : ''
      }` as const,
    ),
  )
}
